import React, { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

export function ConfirmSubmitDialog(props: {
  open: boolean;
  title?: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const {
    open,
    title = "Confirmar pedido",
    description = (
      <Typography>
        Você deseja finalizar e enviar este pedido? Verifique os dados antes de
        confirmar.
      </Typography>
    ),
    confirmLabel = "Confirmar",
    cancelLabel = "Voltar",
    loading = false,
    onConfirm,
    onCancel,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      fullWidth
      maxWidth="xs"
      sx={{
        ".MuiDialog-paper": { borderRadius: 2, px: 1, py: 2 },
      }}
    >
      <DialogTitle fontSize={20} fontWeight={600}>
        {title}
      </DialogTitle>
      <DialogContent dividers>{description}</DialogContent>
      <DialogActions sx={{ gap: 3 }}>
        <Button onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          autoFocus
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
          sx={{ minWidth: 120 }} // Garante que o botão não mude de tamanho
        >
          {loading ? "Enviando..." : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
